export default "__VITE_ASSET__03810870__"